export const AUTH_USER = 'AUTH_USER';
export const AUTH_CHECK = 'AUTH_CHECK';
export const AUTH_LOGIN = 'AUTH_LOGIN';
export const AUTH_LOGOUT = 'AUTH_LOGOUT'
export const USER_ROLE = 'USER_ROLE'
export const ACC_STATUS = 'ACC_STATUS'
export const WORK_SEGEMENT = 'WORK_SEGEMENT'